import { useEffect, useMemo, useState } from 'react';
import { navigateToNewRequest, removeLocalStorage } from '../../helpers/jsHelper';
import { ActionFilters, BigButton } from '../../common';
import { PageSearchBar } from '../../common/UniversalSearchForm/UniversalSearchForm';
import { CommonGrid, TopContainer } from '../../layouts';
import PageTitle from '../../common/PageTitle';
import { useRequests } from '../../hooks/useRequests';
import { COMMON_TAGS_MODEL_TYPES, MODEL_TYPES, STATUS } from '../../constants/constants';
import { useUserContext } from '../../contexts/UserContext';
import { useScreenSettings } from '../../helpers/configureHelper';
import styles from './requests.module.scss';
import './RequestDetails.scss';
import cx from 'classnames';
import icons from '../../assets';
import { Link, useNavigate } from 'react-router-dom';
import RequestThumbnailCardUI from './Sections/RequestThumbnailCardUI';
import { REQUEST_DATA } from '../../config/constant/projectConstant';
import { apiDeleteRequest, apiGetRequestStatusCount } from '../../helpers/api';
import { errorToast, successToast, warningToast } from '../../helpers/toastHelper';
import { useDispatch, useSelector } from 'react-redux';
import {
  select3DModelVariations,
  select3DModels,
  subscriptionSelector,
} from '../../redux/slicers/subscriptionSlicer';
import { EMAIL_VERIFIED } from '../../constants/projectConstants';
import FilterSideModalButton from '../../common/FilterSideModalButton';
import { useInfoDialogaActions } from '../../hooks/useInfoDialogaActions';
import { NEW_REQUEST_ROUTE, REQUEST_DETAIL_ROUTE, REQUEST_EDIT_ROUTE } from '../../constants/routePathConstants';
import { apiGetPurchasedPacks } from '../../api/subscription/subscription';
import { usePageTitle } from '../../hooks/usePageTitle';
import { PRODUCT_ID_ONE, PRODUCT_ID_TWO, navigateToPlans } from '../subscriptionComponents/subscriptionHelper';
import { resetState } from '../../redux/slicers/requestSlicer';
import InfiniteScroll from '../../components/InfiniteScroll/InfiniteScroll';

export const getPurchasedProductPacksList = async (params) => {
  const response = await apiGetPurchasedPacks(params);
  const uniqueProduct = [];

  const checkUniqueProduct = ({ number = null, invoice = null }) => {
    if (!number || !invoice) return false;
    return uniqueProduct.findIndex((a) => a.number === number && a.invoice === invoice) !== -1;
  };

  const data = response.results
    .filter((a) => !a.is_request)
    .reduce((acc, curr) => {
      const list = [...acc];
      const index = list.findIndex(
        (a) =>
          a.product_link_number === curr.product_link_number && a.invoice_id === curr.invoice_id
      );
      if (!checkUniqueProduct({ number: curr.product_link_number, invoice: curr.invoice_id })) {
        uniqueProduct.push({ number: curr.product_link_number, invoice: curr.invoice_id });
        list.push({
          ...curr,
          combinedId: [curr.id],
          seq: curr.product_link_number,
          isPurchased: true,
          title: `Product ${curr.product_link_number}`,
          model_request: { status: 'PURCHASED' },
          product_name: curr?.price?.nickname || curr?.product_name
        });
      } else {
        if (index !== -1) {
          list[index] = {
            ...list[index],
            combinedId: [...(list[index]?.combinedId || []), curr.id],
            product_name: curr?.price?.nickname || `${list[index]?.product_name}, ${curr.product_name}`,
            thumbnail: list[index]?.thumbnail || curr.thumbnail,
          };
        }
      }

      acc = [...list];

      return acc;
    }, []);

  return data || [];
};

export default function Requests({ show = false, cardType = 'requests', useGlobalSearch, title = 'Requests' }) {
  const { currentUser, isGuestUser, guestUserAccess, showAssignPackModal } = useUserContext();
  const { openInfoDialog } = useInfoDialogaActions();
  const [hideChecked, setHideChecked] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [collapseRequest, setCollapseRequest] = useState([]);
  const [isBoardView, setIsBoardView] = useState(true);
  const [requestType, setRequestType] = useState(false);
  const [purchasedPack, setPurchasedPack] = useState([]);
  const [requestStatusCount, setRequestStatusCount] = useState({});
  // const usedProducts = useSelector(select3DModels);
  // const usedModelVariation = useSelector(select3DModelVariations);

  usePageTitle(title);

  // const allProductsUsedCount = useSelector(subscriptionSelector)?.allProductsUsedCount?.filter(
  //   (_item) => _item.product_id === 70 && _item.subscription_id
  // );

  // let finalProductCount = {
  //   [PRODUCT_ID_ONE]: {
  //     title: '3D Model',
  //     total_count: usedProducts?.[0]?.total_count || 0,
  //     available_count: usedProducts?.[0]?.available_count || 0,
  //   },
  //   [PRODUCT_ID_TWO]: {
  //     title: '3D Model Variation',
  //     total_count: usedModelVariation?.[0]?.total_count || 0,
  //     available_count: usedModelVariation?.[0]?.available_count || 0,
  //   },
  // };

  // if (allProductsUsedCount.length) {
  //   allProductsUsedCount.forEach((_item) => {
  //     if (_item.product_id === PRODUCT_ID_ONE) {
  //       finalProductCount[PRODUCT_ID_TWO].available_count += _item.available_count * 2;
  //       finalProductCount[PRODUCT_ID_TWO].total_count += _item.total_count * 2;
  //     }
  //   });
  // }

  const { sortOptions, filterOptions, defaultSortOption, showTeamMemberFilter } =
    useScreenSettings(cardType);
  const { RequestLayoutIcon, RequestBoardViewIcon, SelectArrowDownIcon, InfoIcon } = icons;

  const currentMemberId = currentUser.id;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const requestParams = useMemo(
    () => ({
      created_by: currentMemberId,
      ...(requestType && { model_type: requestType?.value }),
      ...(hideChecked && { hide_closed: 'true' }),
    }),
    [currentMemberId, requestType, hideChecked, showAssignPackModal]
  );

  const {
    list,
    loading,
    fetchMoreData,
    hasMore,
    total,
    hasData,
    sortBy,
    selected,
    filterBy,
    onSortChange,
    refetchList,
    search,
    onSearchChange,
  } = useRequests({
    requestParams,
    filterByKey: 'request_type',
    useGlobalSearch,
    modelType: MODEL_TYPES.REQUEST,
  });

  const getPurchasedPacks = async () => {
    let params = ``
    if (search) {
      params = `&search=${search}`
    }
    if (sortBy?.value) {
      params = `${params}&sort=${sortBy?.value}`
    }
    const results = await getPurchasedProductPacksList(params);
    setPurchasedPack(results);
  };

  const getRequestCount = async () => {
    const param = {
      ...(search && { search: search }),
      ...(requestType && { model_type: requestType?.value }),
      ...(hideChecked && { hide_closed: 'true' }),
    }
    const res = await apiGetRequestStatusCount({params:param})
    setRequestStatusCount(res || {})
  };

  useEffect(() => {
    getPurchasedPacks();
  }, [currentUser?.organization, showAssignPackModal, search, sortBy]);

  useEffect(() => {
    getRequestCount()
  }, [currentUser?.organization, search, hideChecked]);

  const handleRequestClick = (_request) => {
    if (isGuestUser() && _request.model_request.is_internal_team && !guestUserAccess.write) {
      warningToast('You do not have write access. Please contact your admin.');
      return;
    }

    // commented below code to allow guest user to access all the requests - https://app.clickup.com/t/3326989/DEV-31004
    // if (
    //   isGuestUser() &&
    //   _request.model_request.created_by &&
    //   !_request.model_request.is_internal_team
    // ) {
    //   warningToast(
    //     'No access for guest user to view client requests. Check the dashboard for details.'
    //   );
    //   return;
    // }

    if (_request?.isPurchased) {
      dispatch(resetState())
      navigateToNewRequest({
        purchase_id: _request.combinedId.join(','),
        seq: _request.seq,
        is_existing_model: _request?.price?.is_existing_model
      })

      return;
    }

    if (_request.model_request.status === 'DRAFT') {
      window.open(REQUEST_EDIT_ROUTE.replace(':id', _request.id));
    } else navigate(REQUEST_DETAIL_ROUTE.replace(':id', _request.id));
  };
  const handleChange = () => {
    setHideChecked(!hideChecked);
  };

  const handleAddNewRequestClick = () => {
    // removeLocalStorage(REQUEST_DATA);
  };

  const handleCollapse = (_id) => {
    let _collapsedData;
    if (collapseRequest.includes(_id))
      _collapsedData = collapseRequest.filter((_item) => _item !== _id);
    else _collapsedData = [...collapseRequest, _id];

    setCollapseRequest(_collapsedData);
  };

  const handleDelete = async (e, _id, item) => {
    if (isGuestUser() && item.model_request.is_internal_team && !guestUserAccess.write) {
      warningToast('You do not have write access. Please contact your admin.');
      return;
    }

    if (isGuestUser() && item.model_request.created_by && !item.model_request.is_internal_team) {
      warningToast('You do not have access to delete client request.');
      return;
    }

    e.preventDefault();
    openInfoDialog({
      title: `Are you sure you want to delete this ${item?.name || ''} request?`,
      description: '',
      cancelButtonText: 'No',
      buttonText: 'Yes',
      onButtonClick: async () => {
        setDeleteLoading({ ...deleteLoading, ...{ [_id]: true } });
        const response = await apiDeleteRequest(_id);
        if (response?.status) {
          setDeleteLoading({ ...deleteLoading, ...{ [_id]: false } });
          successToast('Request deleted succesfully.');
          getPurchasedPacks();
          refetchList();
          getRequestCount()
        }
      },
      okBtnColor: e?.okBtnColor,
      cancelBtnColor: e?.cancelBtnColor,
      okBtnClassName: e?.okBtnClassName,
    });
  };

  const handlePlanClick = () => navigateToPlans();
  

  const wrapAroundLink = (_component) => (
    <Link to={NEW_REQUEST_ROUTE} target="_blank">
      {_component}
    </Link>
  );

  return (
    <>
    <CommonGrid
      style={show ? { display: 'block' } : { display: 'none' }}
      noDataText={
        search ? (
          `You don't have any ${cardType} with "${search}" name.`
        ) : (
          <div className={styles.noDataText}>
            <div className={styles.mainNoDataText}>
              Your requests live here!
            </div>
            <div className={styles.subNoDataText}>
              This is your request page , where you can create a request and track all process.
            </div>
            <div className={styles.subNoDataText}>
              When you requested a product or service , it will appear here. It looks like you
              haven’t create any request yet.
            </div>
            {!isGuestUser() ? (
              <div className={styles.seeYourPlan} onClick={handlePlanClick}>
                See your plan
              </div>
            ) : null}
            {isGuestUser() && !guestUserAccess?.write ? null : (
              <div className="d-flex justify-content-center">
                {wrapAroundLink(
                  <BigButton
                    className={cx(styles.requestButton, 'm-auto')}
                    onClick={handleAddNewRequestClick}>
                    Add Request
                  </BigButton>
                )}
              </div>
            )}
          </div>
        )
      }
      topContainer={
        <TopContainer
          title={
            !useGlobalSearch && (
              <div>
                <PageTitle title={title} total={total} search={search} />
                {/* <span
                  className={cx('p-1 position-relative', styles.infoWrapper)}
                  style={{ color: '#000000' }}>
                  <InfoIcon />
                  <div className={styles.planInfo}>
                    {Object.keys(finalProductCount)?.map((_item, _index) => (
                      <div key={_index}>
                        <span className={styles.title}>{finalProductCount[_item].title} :</span>
                        <span className={styles.info}>
                          {finalProductCount[_item].available_count}/
                          {finalProductCount[_item].total_count}
                        </span>
                      </div>
                    ))}
                    {!isGuestUser() ? (
                      <div className={styles.seeYourPlan} onClick={handlePlanClick}>
                        See your plan
                      </div>
                    ) : null}
                  </div>
                </span> */}
              </div>
            )
          }
          // buttonArea={<FilterSideModalButton showTeamMemberFilter={showTeamMemberFilter}/>}
          item={cardType}
          hasData={hasData}
          searchBar={
            <div className={cx('mt-3 d-flex justify-content-between', styles.requestTopBarWrapper)}>
              <div
                className={cx(
                  'w-50 d-flex justify-content-start align-items-center',
                  styles.requestTopBar
                )}>
                <PageSearchBar
                  model={COMMON_TAGS_MODEL_TYPES.REQUEST}
                  onSearchChange={onSearchChange}
                  search={search}
                  hideTags={true}
                />
                <div className={styles.requestFilter} onClick={handleChange}>
                  <div className="form-check custom-checkbox">
                    <input
                      type="checkbox"
                      id="sideFilter-favourite"
                      className="form-check-input"
                      checked={hideChecked}
                      onChange={handleChange}
                    />
                    Hide closed request
                  </div>
                </div>
              </div>
              {isGuestUser() && !guestUserAccess?.write
                ? null
                : wrapAroundLink(
                    <BigButton className={styles.requestButton} onClick={handleAddNewRequestClick}>
                      Add Request
                    </BigButton>
                  )}
            </div>
          }
        />
      }
      item={cardType}
      hasData={[...purchasedPack, ...list].length > 0 || loading}
      list={[...purchasedPack, ...list]}
      filterArea={
        !useGlobalSearch && (
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <ActionFilters
                className="request-filter-container"
                filterProps={{
                  value: requestType,
                  data: filterOptions,
                  onChange: (e) => setRequestType(e),
                  placeholder: requestType ? requestType.name : 'Request type',
                }}
              />
              <ActionFilters
                hasData={hasData}
                loading={loading}
                sortProps={{
                  value: sortBy,
                  data: sortOptions,
                  onChange: onSortChange,
                }}
              />
            </div>
            <div className={cx('d-flex gap-3', styles.layoutIcons)}>
              <div
                className={isBoardView ? styles.selected : ''}
                style={{ width: '1.5rem', height: '1.5rem' }}
                onClick={() => setIsBoardView(true)}>
                <RequestBoardViewIcon />
              </div>
              <div
                className={!isBoardView ? styles.selected : ''}
                onClick={() => setIsBoardView(false)}>
                <RequestLayoutIcon />
              </div>
            </div>
          </div>
        )
      }>
      {[...purchasedPack, ...list]?.length ? (
        isBoardView ? (
          <div className="d-flex gap-3" style={{ overflowX: 'auto' }}>
            {STATUS.map((item) =>
              +requestStatusCount[item.value] > 0 || [...purchasedPack, ...list].filter(
                (_item) => _item?.model_request?.status === item.value
              ).length ? (
                <div
                  key={item.name}
                  className={cx(
                    styles.requestWrapper,
                    collapseRequest.includes(item.id) ? styles.autoWidth : ''
                  )}>
                  <div
                    className={cx(
                      styles.header,
                      collapseRequest.includes(item.id) ? styles.collapsedRequests : ''
                    )}
                    style={{ borderColor: item.color }}>
                    {
                      !collapseRequest.includes(item.id) && (
                        <span>
                          {item.name}(
                          {
                            requestStatusCount[item.value]?.toString()?.trim() || [...purchasedPack, ...list].filter((_item) => _item?.model_request?.status === item.value)
                              .length
                          }
                          )
                        </span>
                      )
                    }
                    <div className={styles.arrowIcon} onClick={() => handleCollapse(item.id)}>
                      <SelectArrowDownIcon />
                    </div>
                  </div>
                  {!collapseRequest.includes(item.id) ? (
                    <InfiniteScroll
                      dataLength={
                        requestStatusCount[item.value]?.toString()?.trim() || [...purchasedPack, ...list].filter(
                          (_request) => _request.model_request.status === item.value
                        ).length
                      }
                      next={fetchMoreData}
                      hasMore={hasMore}
                      loading={loading}
                      hasChildren={hasData}
                      scrollableTarget="infiniteScroll">
                      <RequestThumbnailCardUI
                        list={[...purchasedPack, ...list].filter(
                          (_request) => _request.model_request.status === item.value
                        )}
                        selected={selected}
                        deleteLoading={deleteLoading}
                        onCardClick={handleRequestClick}
                        size={4}
                        style={{ width: '100%' }}
                        noDataText=""
                        onDeleteClick={handleDelete}
                        showDataInfo
                      />
                    </InfiniteScroll>
                  ) : (
                    <div
                      className={cx(styles.collapsedRequests, styles.collapseRequestBody)}
                      style={{ borderColor: item.color }}>
                      <div className={styles.collapsedTitle}>{item.name}</div>
                    </div>
                  )}
                </div>
              ) : null
            )}
          </div>
        ) : (
          <div className={cx('d-flex gap-3', styles.cardWrapper)}>
            <InfiniteScroll
              dataLength={[...purchasedPack, ...list].length}
              next={fetchMoreData}
              hasMore={hasMore}
              loading={loading}
              hasChildren={hasData}
              scrollableTarget="infiniteScroll">
              <RequestThumbnailCardUI
                list={[...purchasedPack, ...list]}
                selected={selected}
                deleteLoading={deleteLoading}
                onCardClick={handleRequestClick}
                size={3}
                noDataText=""
                showStatusTag
                onDeleteClick={handleDelete}
                showDataInfo
              />
            </InfiniteScroll>
          </div>
        )
      ) : (
        <></>
      )}
    </CommonGrid>
    </>
  );
}
